/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Keen_Otter_GlowInputs */

const en_warm_keen_otter_glow = /** @type {(inputs: Warm_Keen_Otter_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controls how result values are rounded when displayed. V1 uses truncate, V2 uses half-expand rounding for edge cases.`)
};

const de_warm_keen_otter_glow = /** @type {(inputs: Warm_Keen_Otter_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuert, wie Ergebniswerte bei der Anzeige gerundet werden. V1 verwendet Truncate, V2 verwendet Half-Expand-Rundung für Grenzfälle.`)
};

/**
* | output |
* | --- |
* | "Controls how result values are rounded when displayed. V1 uses truncate, V2 uses half-expand rounding for edge cases." |
*
* @param {Warm_Keen_Otter_GlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_keen_otter_glow = /** @type {((inputs?: Warm_Keen_Otter_GlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Keen_Otter_GlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_keen_otter_glow(inputs)
	return de_warm_keen_otter_glow(inputs)
});